import { render } from "./DutyClassAttend.vue?vue&type=template&id=28d59fa6&scoped=true"
import script from "./DutyClassAttend.vue?vue&type=script&lang=js"
export * from "./DutyClassAttend.vue?vue&type=script&lang=js"

import "./DutyClassAttend.vue?vue&type=style&index=0&id=28d59fa6&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d59fa6"]])

export default __exports__